var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      staticClass: "products-table",
      style: { width: "100%" },
      attrs: { id: "products-table", tag: "table", x: "", y: false },
    },
    [
      _c("thead", { staticClass: "head" }, [
        _c("tr", [
          _c(
            "th",
            { staticStyle: { width: "20px" } },
            [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
            1
          ),
          _c("th", { staticClass: "qty", staticStyle: { width: "60px" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("qty")) + " "),
          ]),
          _c(
            "th",
            {
              staticClass: "description",
              style: { width: _vm.descriptionWidth },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("name")) + " ")]
          ),
          _vm.hasModuleTraceability
            ? _c("th", { staticStyle: { width: "150px" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("tracking-number")) + " "),
              ])
            : _vm._e(),
          _vm.hasModuleTraceability
            ? _c("th", { staticStyle: { width: "130px" } }, [
                _vm._v(
                  " " + _vm._s(_vm.$ct("tracking-number-valid-until")) + " "
                ),
              ])
            : _vm._e(),
          _c("th", { staticStyle: { width: "200px" } }, [
            _vm._v(" " + _vm._s(_vm.$ct("location")) + " "),
          ]),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "148px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("unitPrice")) + " ")]
          ),
          _c(
            "th",
            { staticClass: "align-r", staticStyle: { width: "100px" } },
            [_vm._v(" " + _vm._s(_vm.$ct("total")) + " ")]
          ),
          _c("th", { staticStyle: { width: "32px", "padding-top": "5px" } }),
        ]),
      ]),
      _c(
        "w-scroll-view",
        {
          staticClass: "body",
          attrs: {
            tag: "w-sortable",
            x: "",
            "tag-attributes": _vm.sortableAttributes,
          },
        },
        _vm._l(_vm.items, function (row, i) {
          return _c("app-row", {
            key: i,
            attrs: {
              "row-index": i,
              row: row,
              "is-selected": _vm.selectedRow == row,
            },
            on: {
              edit: function ($event) {
                return _vm.onEditRow(row)
              },
              select: function ($event) {
                return _vm.onRowSelect($event)
              },
              remove: function ($event) {
                return _vm.onRemove(row)
              },
            },
          })
        }),
        1
      ),
      _c("tfoot", { staticClass: "foot" }, [
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "align-r total-label",
              attrs: { colspan: _vm.hasModuleTraceability ? 7 : 5 },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("totalBooked")) + " ")]
          ),
          _c("td", { staticClass: "align-r total-value" }, [
            _vm._v(" " + _vm._s(_vm.totalBooked) + " "),
          ]),
          _c("td", { staticStyle: { width: "32px" } }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }